<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-col cols="12" sm="12">
            <v-card class="box">
                <v-col cols="12" sm="12">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Apply Grading Scheme
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-row justify="center" class="p-0 m-0">
                      <v-col class="p-0 m-0" cols="12" sm="4" md="4" >
                     <v-autocomplete class="pt-2" dense required outlined rounded color="#0F2027" v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" persistent-hint hint="Please select Academic Year" />
                      </v-col>
                    </v-row>
                     <v-row align="center" justify="center" class="p-0 m-0">
                        <v-btn dense outlined rounded class="button" @click="get_all_data()">Proceed</v-btn>
                    </v-row>
                    <span v-if="ay!=null">
                        <span v-if="scheme_list =='not applied'">
                           <v-row justify="center" class="p-0 m-0">
                          <strong>Grading scheme is not offered for this academic year please offer scheme</strong>
                           </v-row>
                        </span>
                     <span v-else>
                    <v-row class="p-0 m-0" v-if="scheme_list.length > 0">
                        <v-col class="p-0 m-0" cols="12" sm="6" md="6"> </v-col>
                        <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                            <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search in table" single-line hide-details></v-text-field>
                        </v-col>
                    </v-row>
                    <!-- {{scheme_list}} -->
                    <v-data-table v-if="scheme_list.length > 0" dense :headers="headers" :items="scheme_list" :search="search" class="elevation-1 mytable" :items-per-page="-1">
                        <template v-slot:item.options="{ item }">
                            <v-btn class="btn-css btn" @click="get_std_crs(item.std_id,item.ay_id)">
                                {{item.std}}
                            </v-btn>
                        </template>
                        <template v-slot:item.scheme="{ item }" class="p-0 m-0">
                          <!-- @change="setscheme(item.std_id,type='std')"  -->
                            <v-row justify="center">
                            <v-autocomplete v-if="item.status != 'No courses for this standard'" class="pt-2 pb-0 m-0" dense required outlined rounded color="#0F2027" v-model="item.apllied_scheme" :items="grading_scheme_list" item-text="s_name" return-object label="Grading Scheme" persistent-hint hint="Please select Grading Scheme" />
                            <v-span justify="center" v-else>
                                No courses offered for standard
                            </v-span>
                            <v-btn rounded v-if="item.status != 'No courses for this standard'"  class="button" @click="setscheme(item.std_id,type='std',null,item.apllied_scheme)">Apply</v-btn>
                            </v-row>
                        </template>
                    </v-data-table>
                    <v-row align="center" justify="center">
                        <v-btn dense outlined v-if="scheme_list.length > 0" rounded class="button" @click="save(scheme_list)">Apply All</v-btn>
                    </v-row>
                    </span>
                    <v-dialog v-model="dialog" persistent max-width="1200px">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong>
                                        Standard Courses
                                    </strong>
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-col cols="12" sm="12" md="12">
                                <v-card class="box">
                                    <v-row justify="center" v-if="crs_list == ''">
                                        <strong>No courses offered for standard</strong>
                                    </v-row>
                                    <v-data-table v-if="crs_list.length > 0" dense :headers="headers1" :items="crs_list" :search="search" class="elevation-1 mytable" :items-per-page="-1">
                                        <template v-slot:item.options="{ item }">
                                           <v-row justify="center">
                                            <v-autocomplete   class="pt-2" dense required outlined rounded color="#0F2027" v-model="item.apllied_scheme" :items="grade_scheme_list" item-text="s_name" return-object label="Grading Scheme" persistent-hint hint="Please select Grading Scheme" />
                                             <!-- <v-span justify="center" v-else>
                                               No courses offered for standard
                                            </v-span> -->
                                             <v-btn rounded  class="button" @click="setscheme(item.std_id,type='course',item.crs_id,item.apllied_scheme)">Apply</v-btn>
                                           </v-row>
                                        </template>
                                    </v-data-table>
                                    <v-row justify="center">
                                        <v-btn rounded class="button" @click="dialog = false">Close</v-btn>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-card>
                    </v-dialog>
                    </span>
                </v-col>
            </v-card>
        </v-col>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                snackbar_msg: null,
                snackbar: false,
                color: "",
                ay_list: [],
                ay: null,
                search: null,
                scheme_list: [],
                crs_list: [],
                dialog: false,
                grade_scheme_list: [],
                scheme: null,
                type: null,
                grading_scheme_list:[],
                std_id:null,
                headers: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },

                    {
                        text: "Academic Year",
                        align: "center",
                        sortable: false,
                        value: "ay",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "options",
                    },
                    {
                        text: "Scheme Status",
                        align: "center",
                        sortable: false,
                        value: "status",
                    },
                    {
                        text: "Apply Scheme",
                        align: "center",
                        sortable: false,
                        value: "scheme",
                    },
                ],
                headers1: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Course",
                        align: "center",
                        sortable: false,
                        value: "crs_name",
                    },
                    {
                        text: "Academic Year",
                        align: "center",
                        sortable: false,
                        value: "ay",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "std",
                    },
                    {
                        text: "Current Scheme",
                        align: "center",
                        sortable: false,
                        value: "gradingscheme",
                    },
                    {
                        text: "Apply Scheme",
                        align: "center",
                        sortable: false,
                        value: "options",
                    },
                ],
            };
        },
        mounted() {
            this.onload();
        },
        methods: {
         save(scheme_list){
              for(var i = 0;i<scheme_list.length;i++){
                 if(scheme_list[i].status != "No courses for this standard"){
                    if(scheme_list[i].apllied_scheme == null){
                        this.showSnackbar("#b71c1c", "Please add assessment scheme to all!!!"); 
                        return
                    }
                    if(scheme_list[i].apllied_scheme != null) {
                        if(scheme_list[i].apllied_scheme.s_id){
                           scheme_list[i].apllied_scheme = scheme_list[i].apllied_scheme.s_id
                        } 
                    }
                 }
             }
              const data = {
                scheme_list : scheme_list
              }
             axios
                    .post("/examination/setGradingAllData",data)
                    .then((res) => {
                       if (res.data.status == "YES") {
                              this.showSnackbar("#4caf50", "Grading Scheme applied successfully");
                              this.onload()
                         }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
          },
          get_all_data(){
            const formData = {
              ay:this.ay
            }
            axios
                    .post("/examination/get_all_gradingscheme_data",formData)
                    .then((res) => {
                        this.scheme_list = res.data.scheme_list;
                        // this.ay_list = res.data.academic_year_list;
                        this.grading_scheme_list = res.data.grading_scheme_list
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
          },
            setscheme(std_id, type,course,grading_scheme) {
                if(grading_scheme == 'undefined' || grading_scheme == null){
                    this.showSnackbar("#b71c1c", "Please select Grading Scheme !!...");
                    return
                }
                if(type == 'std'){
                if(grading_scheme.s_id.length > 1){
                    this.showSnackbar("#b71c1c", "Please select Grading Scheme !!...");
                    return
                }
                }
                const data = {
                    std: std_id,
                    type: type,
                    course: course,
                    grading_scheme: grading_scheme.s_id
                };
                 axios
                    .post("/examination/setgradingscheme", data)
                    .then((res) => {
                         if (res.data.status == "YES") {
                              this.showSnackbar("#4caf50", "Grading Scheme applied successfully");
                              this.dialog = false
                              this.onload()
                         }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
            onload() {
                axios
                    .post("/examination/applyGradingSchemeHome")
                    .then((res) => {
                        this.ay_list = res.data.academic_year_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
            get_std_crs(item, ay) {
                const data = {
                    std: item,
                    ay: ay,
                };
                axios
                    .post("/examination/get_std_crs", data)
                    .then((res) => {
                        this.dialog = true;
                        this.crs_list = res.data.crs_list;
                        this.grade_scheme_list = res.data.scheme_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .mytable /deep/ thead th {
      background: #0F2027;  /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2C5364, #203A43, #0F2027);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2C5364, #203A43, #0F2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0F2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
